function shouldSubmitSearch (event, isComposing) {
  if (isComposing || !event) {
    return false
  }

  const keyCode = event.keyCode || event.which
  return event.isComposing !== true && keyCode !== 229 && event.key !== 'Process'
}

function shouldSyncSearchTerm ({
  isComposing,
  isEditing,
  isSubmitting,
  incomingTerm,
  submittedTerm,
  routeSearchTerm,
}) {
  if (isComposing || isEditing) {
    return false
  }

  if (isSubmitting) {
    return incomingTerm === submittedTerm
  }

  return incomingTerm === routeSearchTerm
}

function shouldApplyAutoCompleteResponse ({
  requestedTerm,
  currentTerm,
  isEditing,
  isSubmitting,
}) {
  return isEditing &&
    !isSubmitting &&
    requestedTerm === currentTerm
}

module.exports = {
  shouldApplyAutoCompleteResponse,
  shouldSubmitSearch,
  shouldSyncSearchTerm,
}
